import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";
import { FileText } from "lucide-react";

export default function TermsPage() {
  return (
    <>
      <PublicHeader />
      <main className="max-w-4xl mx-auto px-4 py-10 pb-24" data-testid="terms-page">
        <div className="tag-cat mb-4">नियम एवं शर्तें</div>
        <h1 className="font-devnagri-heading text-4xl sm:text-5xl font-black text-[#0F172A] leading-tight flex items-center gap-3">
          <FileText className="w-10 h-10 text-indigo-600"/>Terms & Conditions
        </h1>
        <p className="text-slate-500 mt-2 text-sm">अंतिम अपडेट: {new Date().toLocaleDateString("hi-IN", { year: "numeric", month: "long", day: "numeric" })}</p>

        <div className="prose prose-slate max-w-none mt-6 space-y-5 text-slate-700 leading-relaxed">
          <p><b>INDIAN-NEWS-21</b> पोर्टल का उपयोग करके आप निम्नलिखित नियमों और शर्तों को पढ़ने, समझने और उनसे बंधे रहने की सहमति देते हैं। यदि आप इनसे सहमत नहीं हैं, तो कृपया पोर्टल का उपयोग न करें।</p>

          <h2 className="font-devnagri-heading text-2xl font-black text-[#0F172A] mt-8">1. सेवा का उपयोग</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>यह पोर्टल केवल <b>18 वर्ष एवं उससे अधिक</b> आयु के व्यक्तियों के व्यक्तिगत, गैर-व्यावसायिक उपयोग के लिए है।</li>
            <li>पोर्टल की सामग्री तक पहुँच निःशुल्क है, हालाँकि कुछ premium features के लिए शुल्क लागू हो सकता है।</li>
            <li>आप पोर्टल का उपयोग किसी भी अवैध, अनैतिक या हानिकारक उद्देश्य के लिए नहीं कर सकते।</li>
          </ul>

          <h2 className="font-devnagri-heading text-2xl font-black text-[#0F172A] mt-8">2. बौद्धिक संपदा अधिकार</h2>
          <p>पोर्टल पर प्रकाशित <b>सभी सामग्री</b> — समाचार, लेख, फ़ोटो, वीडियो, लोगो, डिज़ाइन, कोड — INDIAN-NEWS-21 और/या इसके लाइसेंसरों की बौद्धिक संपदा है और भारतीय कॉपीराइट अधिनियम 1957 के तहत सुरक्षित है।</p>
          <p><b>निषेध:</b></p>
          <ul className="list-disc pl-6 space-y-2">
            <li>बिना लिखित अनुमति के किसी भी सामग्री का पुनःप्रकाशन, वितरण, अनुकूलन</li>
            <li>वेबसाइट का scraping, mirroring या automated data extraction</li>
            <li>Watermark, brand logo, credit lines को हटाना या बदलना</li>
            <li>व्यावसायिक लाभ के लिए सामग्री का पुन: उपयोग</li>
          </ul>
          <p>उल्लंघन पर <b>कड़ी क़ानूनी कार्रवाई</b> की जाएगी।</p>

          <h2 className="font-devnagri-heading text-2xl font-black text-[#0F172A] mt-8">3. उपयोगकर्ता योगदान (User Content)</h2>
          <p>जब आप "Reader Contribution", टिप्पणी, वीडियो, फ़ोटो या कोई अन्य सामग्री जमा करते हैं, तो आप:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>पुष्टि करते हैं कि आप उस सामग्री के मालिक हैं और उसे प्रकाशित करने का अधिकार रखते हैं</li>
            <li>INDIAN-NEWS-21 को उस सामग्री का उपयोग, संपादन, प्रकाशन, वितरण और archive करने का <b>गैर-अनन्य, रॉयल्टी-मुक्त, वैश्विक लाइसेंस</b> प्रदान करते हैं</li>
            <li>आश्वासन देते हैं कि सामग्री में कोई गैर-कानूनी, मानहानिकारक, अश्लील, नफ़रत-प्रेरक या भ्रामक तत्व नहीं है</li>
            <li>पूरी क़ानूनी ज़िम्मेदारी वहन करते हैं यदि आपकी सामग्री किसी तीसरे पक्ष के अधिकारों का उल्लंघन करती है</li>
          </ul>

          <h2 className="font-devnagri-heading text-2xl font-black text-[#0F172A] mt-8">4. निषिद्ध व्यवहार</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>वेबसाइट पर आक्रामक, नस्लवादी, धार्मिक/जातीय अपमानजनक टिप्पणी करना</li>
            <li>फ़र्ज़ी खबरें, hoax या misinformation पोस्ट करना</li>
            <li>Spam, phishing links या malware फैलाना</li>
            <li>दूसरे उपयोगकर्ताओं की व्यक्तिगत जानकारी अनधिकृत रूप से एकत्र करना</li>
            <li>वेबसाइट के infrastructure में हस्तक्षेप करना (DDoS, hacking attempts)</li>
          </ul>
          <p>ऐसे किसी भी उपयोगकर्ता का account तत्काल प्रभाव से बंद कर दिया जाएगा और आवश्यक हो तो साइबर अपराध शाखा को सूचित किया जाएगा।</p>

          <h2 className="font-devnagri-heading text-2xl font-black text-[#0F172A] mt-8">5. विज्ञापन एवं तृतीय पक्ष सेवाएँ</h2>
          <p>पोर्टल पर तृतीय पक्ष विज्ञापन (Google AdSense, direct advertisers) दिखाए जा सकते हैं। इन विज्ञापनों में दिए गए दावों, उत्पादों या सेवाओं के लिए INDIAN-NEWS-21 ज़िम्मेदार नहीं है।</p>

          <h2 className="font-devnagri-heading text-2xl font-black text-[#0F172A] mt-8">6. सेवा में परिवर्तन एवं समाप्ति</h2>
          <p>हम बिना पूर्व सूचना के पोर्टल की किसी भी सेवा को संशोधित, स्थगित या समाप्त करने का अधिकार सुरक्षित रखते हैं। हम किसी भी उपयोगकर्ता का access किसी भी समय, बिना कारण बताए, समाप्त कर सकते हैं।</p>

          <h2 className="font-devnagri-heading text-2xl font-black text-[#0F172A] mt-8">7. देयता की सीमा</h2>
          <p>INDIAN-NEWS-21, इसके संचालक, संपादक, कर्मचारी और सहयोगी किसी भी परिस्थिति में पोर्टल के उपयोग या इसमें उपलब्ध सामग्री पर विश्वास करके किए गए निर्णयों से हुई किसी भी प्रकार की हानि (प्रत्यक्ष, अप्रत्यक्ष, आकस्मिक, विशेष, परिणामी) के लिए ज़िम्मेदार नहीं होंगे।</p>

          <h2 className="font-devnagri-heading text-2xl font-black text-[#0F172A] mt-8">8. क्षतिपूर्ति</h2>
          <p>आप INDIAN-NEWS-21 और इसके सभी अधिकारियों को आपके द्वारा नियमों के उल्लंघन, गलत जानकारी देने, या तृतीय पक्ष के अधिकारों के उल्लंघन से उत्पन्न किसी भी claim, हानि या क़ानूनी खर्च से मुक्त रखने के लिए सहमत हैं।</p>

          <h2 className="font-devnagri-heading text-2xl font-black text-[#0F172A] mt-8">9. लागू क़ानून एवं अधिकार क्षेत्र</h2>
          <p>ये नियम <b>भारतीय क़ानून</b> के अनुसार शासित होंगे। कोई भी विवाद <b>सूरजपुर (छत्तीसगढ़)</b> की न्यायिक सीमा के अंतर्गत आने वाले न्यायालयों के अनन्य अधिकार क्षेत्र में सुलझाया जाएगा।</p>

          <h2 className="font-devnagri-heading text-2xl font-black text-[#0F172A] mt-8">10. संशोधन</h2>
          <p>हम इन नियमों को बदलने का अधिकार सुरक्षित रखते हैं। सभी बदलाव इसी पेज पर प्रकाशित होंगे और प्रकाशन तिथि से प्रभावी होंगे।</p>

          <div className="mt-8 p-4 rounded-lg bg-slate-50 border-l-4 border-indigo-600 text-sm">
            <b>क़ानूनी संपर्क:</b><br/>
            प्रधान संपादक JAKIR MOMIN<br/>
            INDIAN-NEWS-21<br/>
            सिरसी नवापारा, मेन रोड, सूरजपुर, छत्तीसगढ़ — 497231<br/>
            📧 <a href="mailto:mdjkbaba786@gmail.com" className="text-[#DC2626] font-bold hover:underline">mdjkbaba786@gmail.com</a> · 📞 <a href="tel:+918463860303" className="text-[#DC2626] font-bold hover:underline">+91 8463860303</a>
          </div>
        </div>
      </main>
      <PublicFooter />
    </>
  );
}
